import { RouteLocationNormalized } from 'vue-router'

import { useStoreRooms } from '@/entities/room'

import { Room } from '@/shared/types/store'
import { resolvePrepareToCallRoomId } from '@/shared/utils/router'
import { toPServedUser } from '@/shared/utils/uri'

export const prepareToCallPropsFn  = (to: RouteLocationNormalized): {
  room: Room
} => {
  const roomId = resolvePrepareToCallRoomId(to.params.roomId as string)
  const storeRooms = useStoreRooms()
  let room = storeRooms.getRoomById(roomId) ?? storeRooms.findByPServed?.(toPServedUser(roomId, true))
  if (!room && storeRooms.createEmptyGroupRoom) {
    storeRooms.createEmptyGroupRoom(toPServedUser(roomId, true))
    room = storeRooms.getRoomById(roomId) ?? storeRooms.findByPServed?.(toPServedUser(roomId, true))
  }
  if (!room) {
    throw new Error('No room found')
  }
  return {
    room,
  }
}
